import { EnvironmentDto } from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';

export interface InitializeStepPrecheck {
  type: Constants.INITIALIZE_STEP_PRECHECK;
  payload: {
    environmentId: string;
  };
}

export interface InitializeStepPrecheckSuccess {
  type: Constants.INITIALIZE_STEP_PRECHECK_SUCCESS;
  payload: {
    environment?: EnvironmentDto;
  };
}

export interface InitializeStepPrecheckFailed {
  type: Constants.INITIALIZE_STEP_PRECHECK_FAILED;
}

export type StepPrecheckAction =
  | InitializeStepPrecheck
  | InitializeStepPrecheckFailed
  | InitializeStepPrecheckSuccess;

export const initializeStepPrecheck = (
  environmentId: string
): InitializeStepPrecheck => ({
  type: Constants.INITIALIZE_STEP_PRECHECK,
  payload: { environmentId }
});

export const initializeStepPrecheckSuccess = (
  environment?: EnvironmentDto
): InitializeStepPrecheckSuccess => ({
  payload: {
    environment
  },
  type: Constants.INITIALIZE_STEP_PRECHECK_SUCCESS
});

export const initializeStepPrecheckFailed = (): InitializeStepPrecheckFailed => ({
  type: Constants.INITIALIZE_STEP_PRECHECK_FAILED
});
